import { createSelector } from 'reselect';

const vendorTeamMemberReducer = (state) => state.get('vendorTeamMemberReducer');

export const vendorSelector = createSelector(vendorTeamMemberReducer, (state) =>
  state.get('vendor').toJS(),
);

export const vendorLoadingSelector = createSelector(
  vendorTeamMemberReducer,
  (state) => state.get('loading'),
);
